var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{attrs:{"icon":"","flat":""},on:{"click":_vm.setItem}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("edit")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }